export const radiobuttonTheme = {
  colorScheme: {
    light: {
      root: {
        width: '1.125rem',
        height: '1.125rem',
        checkedBackground: '{primary.color}',
        checkedHoverBackground: 'transparent',
        disabledBackground: '{form.field.disabled.background}',
        filledBackground: '{form.field.filled.background}',
        borderColor: '{form.field.border.color}',
        hoverBorderColor: '{form.field.hover.border.color}',
        focusBorderColor: '{form.field.focus.border.color}',
        checkedBorderColor: '{primary.color}',
        checkedHoverBorderColor: '{primary.hover.color}',
        checkedFocusBorderColor: '{primary.color}',
        checkedDisabledBorderColor: '{form.field.border.color}',
        invalidBorderColor: '{form.field.invalid.border.color}',
        shadow: '{form.field.shadow}',
        focusRing: {
          width: '{focus.ring.width}',
          style: '{focus.ring.style}',
          color: '{focus.ring.color}',
          offset: '{focus.ring.offset}',
          shadow: '{focus.ring.shadow}'
        },
        transitionDuration: '{form.field.transition.duration}',
        sm: {
          width: '1rem',
          height: '1rem'
        },
        lg: {
          width: '1.25rem',
          height: '1.25rem'
        }
      },
      icon: {
        size: '0.5rem',
        checkedColor: '{primary.contrast.color}',
        checkedHoverColor: '{primary.color}',
        disabledColor: '{form.field.disabled.color}',
        sm: {
          size: '0.4rem'
        },
        lg: {
          size: '0.625rem'
        }
      }
    },
    dark: {
      root: {
        width: '1.125rem',
        height: '1.125rem',
        checkedBackground: '{primary.color}',
        checkedHoverBackground: 'transparent',
        disabledBackground: '{form.field.disabled.background}',
        filledBackground: '{form.field.filled.background}',
        borderColor: '{form.field.border.color}',
        hoverBorderColor: '{form.field.hover.border.color}',
        focusBorderColor: '{form.field.focus.border.color}',
        checkedBorderColor: '{primary.color}',
        checkedHoverBorderColor: '{primary.hover.color}',
        checkedFocusBorderColor: '{primary.color}',
        checkedDisabledBorderColor: '{form.field.border.color}',
        invalidBorderColor: '{form.field.invalid.border.color}',
        shadow: '{form.field.shadow}',
        focusRing: {
          width: '{focus.ring.width}',
          style: '{focus.ring.style}',
          color: '{focus.ring.color}',
          offset: '{focus.ring.offset}',
          shadow: '{focus.ring.shadow}'
        },
        transitionDuration: '{form.field.transition.duration}',
        sm: {
          width: '1rem',
          height: '1rem'
        },
        lg: {
          width: '1.25rem',
          height: '1.25rem'
        }
      },
      icon: {
        size: '0.5rem',
        checkedColor: '{primary.contrast.color}',
        checkedHoverColor: '{primary.color}',
        disabledColor: '{form.field.disabled.color}',
        sm: {
          size: '0.4rem'
        },
        lg: {
          size: '0.625rem'
        }
      }
    }
  }
};
